/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.hideTask = function(id) {
  const task = $('#task-' + id);
  const list = task.closest('.list');
  const showHidden = list.hasClass('show-hidden');
  const where = list.find('.task:visible:not(.hidden):last').first();
  const speed = showHidden && (where.next().is(task) || where.is(task)) ? 0 : 'slow';
  return task.slideUp(speed, function() {
    task.insertAfter(where);
    task.addClass('hidden');
    if (showHidden) {
      return task.slideDown(speed, () => task.css({display: ''}));
    } else {
      return task.css({display: ''});
    }
  });
};

root.unhideTask = function(id) {
  const task = $('#task-' + id);
  const list = task.closest('.list');
  const where = list.find('.task.hidden:first').first();
  const speed = where.prev().is(task) || where.is(task) ? 0 : 'slow';
  return task.slideUp(speed, function() {
    task.insertBefore(where);
    task.removeClass('hidden');
    return task.slideDown(speed, () => task.css({display: ''}));
  });
};

root.removeTask = function(id) {
  const task = $('#task-' + id);
  const list = task.closest('.list');
  return task.slideUp('slow', () => task.remove());
};

root.initRemoteModals = () => $("*[data-reveal-ajax]").click(function(event) {
  event.preventDefault();
  const $this = $(this);
  return $.ajax($this.attr('href')).done(resp => $("#" + $this.data('open-ajax')).html(resp).foundation('open'));
});

function showHiddenStorageKey(list) {
  return 'show-hidden-' + (list.attr('id') || 'default');
}

// Off before on: this function is called on both jQuery ready and turbo:load,
// so we must remove any existing handler to prevent double-firing toggleClass.
function revealHiddenTasks(list) {
  list.find('.task.hidden').removeClass('hidden');
}

root.initToggleHiddenTasksButtons = function() {
  // Restore persisted state: remove .hidden class so tasks render normally
  $('.list').each(function() {
    var list = $(this);
    if (localStorage.getItem(showHiddenStorageKey(list)) === 'true') {
      revealHiddenTasks(list);
    }
  });

  $('.toggle-hidden-tasks').off('click.toggleHidden').on('click.toggleHidden', function(event) {
    event.preventDefault();
    var list = $(this).closest('.list');
    revealHiddenTasks(list);
    localStorage.setItem(showHiddenStorageKey(list), 'true');
  });
};

root.initCivicOpportunities = function() {
  if ($("*[data-reveal-ajax]").length) {
    initRemoteModals();
  }
  $(".task a[disabled]").attr({'disabled': false});
  return initToggleHiddenTasksButtons();
};

$(initCivicOpportunities);
document.addEventListener('turbo:load', initCivicOpportunities);
